// src/pages/SetupProfilePage.tsx
import { useState } from "react";
import { db, auth, functions } from "../../config/firebaseConfig";
import { useToast } from "../../util/ToastProvider";
import { httpsCallable } from "firebase/functions";
import ProfileFormComponent from "../../components/ProfileFormComponent";
import { ProfileForm } from "../../components/profile/ProfileFields";
import { useNavigate } from "react-router-dom";

export default function SetupProfilePage() {
  const [formData, setFormData]= useState<ProfileForm | null>()
  const { success, error } = useToast();
  const navigate = useNavigate();

  const handleSave = async(form: any) => {
    await new Promise(resolve => setTimeout(resolve, 5000));
    console.log(form);
    const userHandler = httpsCallable(functions, "authUserHandler");
    try{
      await userHandler({
        type: "setupBasicProfile",
        profile:form,
        email: auth.currentUser?.email
      });
      success("Profile saved")
      console.log("✅ Profile saved:", { profile: form});
      navigate("/", { replace: true });
    } catch(e){
      error("Error while saving Profile")
      console.log(e)
    }
  }

  

  return <ProfileFormComponent isRelated={false} isSetupProfile={true} initialData={formData} onSave={handleSave} />;
}


